'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = require('react-svg');

var _reactSvg2 = _interopRequireDefault(_reactSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Robot = function Robot(_ref) {
  var bsStyle = _ref.bsStyle,
      size = _ref.size,
      alternate = _ref.alternate;

  return _react2.default.createElement(
    'div',
    { className: 'robot robot-' + size },
    _react2.default.createElement(
      'div',
      { className: 'robot-bg' },
      _react2.default.createElement(_reactSvg2.default, { path: 'https://static.ux.cimpress.io/assets/images/bg_diamond-' + bsStyle + '.svg' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'robot-figure' },
      _react2.default.createElement(_reactSvg2.default, { path: 'https://static.ux.cimpress.io/assets/images/robot-' + bsStyle + (alternate ? '-2' : '') + '.svg' })
    )
  );
};

Robot.propTypes = {
  bsStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger']),
  size: _propTypes2.default.oneOf(['sm', 'lg']),
  alternate: _propTypes2.default.bool
};

Robot.defaultProps = {
  bsStyle: 'success',
  size: 'sm'
};

exports.default = Robot;